import { faMoneyBill } from '@fortawesome/pro-regular-svg-icons';
import { useParams } from '@tanstack/react-router';
import {
	ShipmentDtoTsoStatus as OrderStatus,
	ShipmentDtoShipmentStatus as ShipmentStatus,
} from '@uturn/api/v2';
import { shipmentStatusTsoName } from '@uturn/portal/modules/shipments/utils';
import { Button, FormFieldReadOnly, Icon, Label } from '@uturn/ui-kit';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FinancialsSheet } from '../financials-sheet';
import { ShipmentStatusBadge } from '../shipment-status-badge';

export type ShipmentStatusInfoProps = {
	shipmentStatus?: ShipmentStatus;
	orderStatus?: OrderStatus;
};

export function ShipmentStatusInfo({
	shipmentStatus,
	orderStatus,
}: ShipmentStatusInfoProps) {
	const { t } = useTranslation();
	const { shipmentNumber: id } = useParams({
		from: '/_protected/shipments/$shipmentNumber',
	});

	const [openFinancialsSheet, setOpenFinancialsSheet] = useState(false);

	const showOrderStatus =
		orderStatus !== OrderStatus.CANCELLED &&
		orderStatus !== OrderStatus.OPEN &&
		orderStatus !== undefined;

	const showFinancials =
		orderStatus === OrderStatus.INVOICED ||
		orderStatus === OrderStatus.COST_DECLARED;

	return (
		<>
			<div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-6">
				<div className="sm:col-span-full">
					<Label>
						{t('pages.order.shipment-details.status.heading', 'Status')}
					</Label>
					<div className="mt-1">
						<ShipmentStatusBadge status={shipmentStatus} />
					</div>
				</div>
				{showOrderStatus && (
					<div className="sm:col-span-full">
						<Label>
							{t(
								'pages.order.shipment-details.tso-status.heading',
								'Order status',
							)}
						</Label>
						<FormFieldReadOnly value={shipmentStatusTsoName(t)[orderStatus]} />
						<div className="mt-2 flex gap-4">
							{showFinancials && (
								<div className="sm:col-span-4">
									<Button
										variant="secondary"
										size="sm"
										className="flex items-center gap-2"
										onClick={(e) => {
											e.preventDefault();
											setOpenFinancialsSheet(true);
										}}
									>
										<Icon
											icon={faMoneyBill}
											className="text-secondary-600 size-3.5"
										/>
										{t(
											'pages.order.shipment-details.actions.financials',
											'Financials',
										)}
									</Button>
								</div>
							)}
						</div>
					</div>
				)}
			</div>
			<FinancialsSheet
				openSheet={openFinancialsSheet}
				setOpenSheet={setOpenFinancialsSheet}
				shipmentNumber={String(id)}
			/>
		</>
	);
}
